// Announcement Bar Web Component

if (!customElements.get('announcement-carousel')) {
  class AnnouncementCarousel extends HTMLElement {
    connectedCallback() {
      // connectedCallback fires again if the element is moved in the DOM
      if (this.initialized) return;
      this.initialized = true;

      this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
      if (!this.slides.length) return;

      this.speed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
      this.current = 0;
      this.timer = null;
      this.userPaused = false;

      this.setupClickHandlers();

      // A single announcement has nothing to rotate through
      if (this.slides.length <= 1) return;

      this.nextButton = this.querySelector('[data-carousel-next]');
      this.prevButton = this.querySelector('[data-carousel-prev]');

      this.nextButton?.addEventListener('click', () => {
        this.next();
        this.pauseFromUser();
      });

      this.prevButton?.addEventListener('click', () => {
        this.prev();
        this.pauseFromUser();
      });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    // Each block's "Click JS" setting is compiled once and called with
    // `this` = the slide element, plus (event, slide) as arguments.
    setupClickHandlers() {
      this.slides.forEach((slide) => {
        const code = slide.getAttribute('data-click-js');
        if (!code) return;

        let handler;
        try {
          handler = new Function('event', 'slide', code);
        } catch (error) {
          console.error(`[announcement-bar] invalid Click JS on block ${slide.dataset.index}`, error);
          return;
        }

        slide.addEventListener('click', (event) => {
          try {
            handler.call(slide, event, slide);
          } catch (error) {
            console.error(`[announcement-bar] Click JS failed on block ${slide.dataset.index}`, error);
          }
        });
      });
    }

    show(index) {
      this.current = (index + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, i) => {
        const active = i === this.current;
        slide.classList.toggle('is-active', active);

        if (active) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });
    }

    next() {
      this.show(this.current + 1);
    }

    prev() {
      this.show(this.current - 1);
    }

    start() {
      this.stop();
      if (this.userPaused) return;
      this.timer = setInterval(() => this.next(), this.speed);
    }

    stop() {
      if (!this.timer) return;
      clearInterval(this.timer);
      this.timer = null;
    }

    // Once the user takes control via a button, autoplay stays paused.
    pauseFromUser() {
      this.userPaused = true;
      this.stop();
    }
  }

  customElements.define('announcement-carousel', AnnouncementCarousel);
}
